





























































































































































































































































import Vue from 'vue';
import {
  Component,
  Prop,
} from 'vue-property-decorator';
import { VMoney } from 'v-money';
import UserProfile from '@/domain/access/domain/profile.enum';
import IconInfoDescription from '@/shared/icons/icon-info-description.component.vue';
import KeyValueParameter from '@/shared/parameters/key-value-parameter.component.vue';
import CurrencyConvertComponent from '@/shared/parameters/currency-convert-component.vue';
import RoleComponent from '@/shared/parameters/role-component.vue';
import Rules from '@/shared/rules/rules';
import BooleanType from './boolean-type.json';

@Component({
  components: {
    IconInfoDescription,
    KeyValueParameter,
    CurrencyConvertComponent,
    RoleComponent,
  },
  directives: {
    money: VMoney,
  },
})
export default class ManageCalculationParameters extends Vue {
  @Prop() rules!: any;

  @Prop() editMode!: boolean;

  @Prop() isAdministrator!: boolean;

  @Prop() restrictRules!: any;

  @Prop() profile!: string;

  readonly: boolean = false;

  ref: any = this.$refs;

  validationsRules: Rules = new Rules();

  arrayOfStripRanges: [] = [];

  rangeQuantity: number = 2;

  stringListInput = '';

  booleanType = BooleanType;

  get genericRange() {
    return {
      index: 0,
      quantidadeInicial: 1,
      quantidadeFinal: 2,
      valor: '0.01',
    };
  }

  valueText(type: string): string {
    if (type === 'RANGE' || type === 'RANGE2') {
      return 'Valor';
    }
    return 'Percentual'
  }

  getDirectiveByType(type: string) {
    if (type === 'MONEY2' || type === 'RANGE2') {
      return this.money2;
    }
    if (type === 'RANGE') {
      return this.money;
    }
    if (type === 'RANGE_PERCENT2') {
      return this.percent2;
    }
    return this.percent;
  }

  getRulesByType(type: string) {
    if (type === 'MONEY2' || type === 'RANGE2' || type === 'RANGE_PERCENT2') {
      return this.validationsRules.money2EqualOrBiggerThanZero
    }
    return this.validationsRules.moneyEqualOrBiggerThanZero;
  }

  checkRuleRestrict(ruleId: string): boolean {
    const ruleRestrictExists = this.restrictRules.find((el) => el.id === ruleId);
    if (ruleRestrictExists) return true;
    return false;
  }

  checkDisabledField(ruleId: string): boolean {
    return (!this.isAdministrator && !this.isGPProfile) || this.checkReadOnlyField(ruleId);
  }

  checkReadOnlyField(ruleId: string): boolean {
    if (this.editMode) {
      return this.restrictRules.length > 0 && !this.checkRuleRestrict(ruleId);
    }
    return !this.editMode;
  }

  get isGPProfile() {
    return this.profile === UserProfile.GP;
  }

  get money() {
    return {
      decimal: ',',
      thousands: '.',
      precision: 2,
      prefix: '$ ',
      masked: false,
      max: 9999.99,
      min: 0.01,
    };
  }

  get money2() {
    return {
      decimal: ',',
      thousands: '.',
      precision: 4,
      prefix: '$ ',
      masked: false,
      max: 9999.9999,
      min: 0.0001,
    };
  }

  percent: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: '% ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  }

  percent2: object = {
    decimal: ',',
    thousands: '.',
    precision: 4,
    prefix: '% ',
    masked: false,
    max: 9999.9999,
    min: 0.0001,
  }

  sendRangeParameters() {
    this.$emit('rangeParameters', this.rules);
  }
}
